/**
 * Flow Session Utilities
 * Pure helper functions related to the flow session lifecycle.
 * No React dependencies — safe to use outside of components.
 */

/** Detect whether the app is running inside an iframe (embedded mode). */
export function detectEmbedded(): boolean {
  try {
    return globalThis.self !== globalThis.top;
  } catch {
    return true;
  }
}
